import { Card, Grid, Typography } from "@mui/material";
import Iconify from "../../../components/minimal/iconify/index.jsx";
import useResponsive from "../../../hooks/minimal/useResponsive.jsx";
import { MotionViewport, varFade } from "../../../components/minimal/animate/index.jsx";
import { m } from "framer-motion";

export const CardFeature = ({ iconName, title, subTitle }) => {

    const isMobile = useResponsive('down', 'md');
    const width = isMobile ? "100%" : "380px";

    return (
        <MotionViewport sx={{ height: '100%', width }}>
            <m.div variants={varFade().inUp} sx={{ height: '100%' }}>
                <Grid
                    component={Card}
                    item
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        p: isMobile ? 2 : 4,
                        gap: 2,
                        height: "100%",
                        minHeight: "240px",
                    }}
                >
                    <Iconify width="40px" icon={iconName} color="primary.main" />
                    <Typography variant="h5">
                        {title}
                    </Typography>
                    <Typography variant="subtitle2">
                        {subTitle}
                    </Typography>
                </Grid>
            </m.div>
        </MotionViewport>
    )
}
